import { Typography, Button, Modal, Box, TextField, IconButton, InputAdornment, OutlinedInput, InputLabel } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import usePost from 'src/hooks/usePost';
import { toast } from 'react-toastify';
import useHooks from 'src/hooks/useHooks';

function AddUser({ refetch }: { refetch: () => void }) {
    const {navigate,get}=useHooks()
    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        borderRadius: '16px',
        boxShadow: 24,
        p: 4,
    };

    const [showPassword, setShowPassword] = useState(false);
    const [open, setOpen] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const { mutateAsync } = usePost();

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const userData = { username, password };
        toast.promise(
            mutateAsync({ method: "post", url: "/register/user", data: userData }),
            {
                pending: 'Yaratilmoqda...',
                success: {
                  render(){
                    setOpen(false);
                    refetch()
                    return 'Foydalanuvchi muvoffaqiyatli yaratildi!'
                  }
                },
                error: {
                  render({ data }) {
                    return `Error: ${JSON.stringify(get(data,'response.data')) }`;
                  },
                },
            }
        )
    };
    return (
        <>
            <Button
                sx={{ mt: { xs: 2, md: 0 } }}
                variant="contained"
                onClick={handleOpen}
                startIcon={<AddTwoToneIcon fontSize="small" />}
            >
                Foydalanuvchi qo'shish
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h3" component="h2">
                        Yangi foydalanuvchi qo'shish
                    </Typography>
                    <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column" }}>
                        <TextField
                            style={{ marginTop: "15px" }}
                            label="Foydalanuvchi nomi"
                            variant="outlined"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <InputLabel style={{ marginTop: "15px" }} htmlFor="outlined-adornment-password">Parol *</InputLabel>
                        <OutlinedInput
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            aria-required
                            onChange={(e) => setPassword(e.target.value)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            placeholder='Parol *'
                            required
                        />

                        <Button
                            style={{ marginTop: "20px" }}
                            sx={{ mt: { xs: 2, md: 0 } }}
                            variant="contained"
                            type='submit'
                            startIcon={<AddTwoToneIcon fontSize="small" />}
                        >
                            Qo'shish
                        </Button>
                    </form>
                </Box>
            </Modal>
        </>
    );
}

export default AddUser;
